<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <button filtros mat-stroked-button (click)="downloadPlantilla()">
    <mat-icon>save_alt</mat-icon>
    {{'gestion.formulacion.alta-proyectos.download' | translate}}
  </button>
  <button filtros mat-stroked-button (click)="uploadPlantilla()"
   [disabled]="!canUpload">
    {{'gestion.formulacion.alta-proyectos.upload' | translate}}
  </button>
  <div filtros [ngClass]="{'w3-disabled': registros.length === 0 || !completeAll}">
    <button mat-stroked-button (click)="selecSave()">
      <mat-icon>save</mat-icon>
      {{'gestion.formulacion.alta-proyectos.save' | translate}}
    </button>
  </div>

  <div contenido class="tableAlta">
    <div class="tarjetasInfo">
      <mat-card class="tarjetInf">
        <div class="contenidoTarjeta">
          <div class="tituloTarjeta">
            {{'gestion.formulacion.alta-proyectos.total' | translate}}
          </div>
          <div class="cifraTarjeta">{{total}}</div>
        </div>
      </mat-card>
      <mat-card class="tarjetInf">
        <div class="contenidoTarjeta">
          <div class="tituloTarjeta">
            {{'gestion.formulacion.alta-proyectos.ready' | translate}}
          </div>
          <div class="cifraTarjeta">{{ready}}</div>
        </div>
      </mat-card>
      <mat-card class="tarjetInf">
        <div class="contenidoTarjeta">
          <div class="tituloTarjeta">
            {{'gestion.formulacion.alta-proyectos.error' | translate}}
          </div>
          <div class="cifraTarjeta">{{error}}</div>
        </div>
      </mat-card>
    </div>
    <div class="informacion">
      <span>{{'gestion.formulacion.alta-proyectos.info' | translate}}</span>
      {{'gestion.formulacion.alta-proyectos.incompleto' | translate}}
      <span>{{'gestion.formulacion.alta-proyectos.info2' | translate}}</span>
    </div>
    <app-contenedor-elementos class="showProyects" [header]="{
      title: ''
    }">
      <mat-icon iconos class="iconoMen" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menu2">
        more_vert</mat-icon>
      <mat-menu #menu2="matMenu">
        <button (click)="proyectosAlta = !proyectosAlta" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
          <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
          @if (!proyectosAlta) {
            <span>{{'gestion.formulacion.alta-proyectos.altaProy' | translate}}</span>
          }@else {
            <span>{{'gestion.formulacion.alta-proyectos.verProy' | translate}}</span>
          }
        </button>
      </mat-menu>
      <div body class="espacioTablas">
        @if (proyectosAlta) {
          <table class="tabla-aleema">
            <thead>
              <tr>
                @for (e of encabezados; track e; let i = $index) {
                  <th>
                    {{'gestion.formulacion.alta-proyectos.encabezado'+(i+1) | translate}}
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (item of registros; track $index) {
                <tr>
                  <!-- Estatus -->
                  <td style="text-align: center;">
                    <span class="badge"
                    [class.badge-completo]="item.status"
                    [class.badge-incompleto]="!item.status">
                      {{'gestion.formulacion.alta-proyectos.'+item.status | translate}}
                    </span>
                  </td>
                  <!-- Tipo -->
                  <td style="text-align: center;">
                    <span class="badge"
                    [class.badge-proyecto]="item.tipo === 'p'"
                    [class.badge-actividad]="item.tipo === 'a'">
                      {{'gestion.formulacion.alta-proyectos.'+item.tipo | translate}}
                    </span>
                  </td>
                  <!-- Nombre -->
                  <td style="padding-left: 0.5rem;" [matTooltip]="item.name" [appOverflowTooltip]="item.name">
                    {{item.name}}
                  </td>
                  <!-- Descripcion  -->
                  @if (item.tipo === 'p') {
                    <td style="padding-left: 0.5rem;" [matTooltip]="item.description" [appOverflowTooltip]="item.description">
                      {{item.description}}
                    </td>
                  }@else {
                    <td style="text-align: center;">
                      <mat-icon>
                        minimize
                      </mat-icon>
                    </td>
                  }
                  <!-- Objetivo -->
                  @if (item.tipo === 'p') {
                    <td style="max-width: 8vw;">
                      <select
                        class="cell-select"
                        [(ngModel)]="item.objetiveId"
                        (ngModelChange)="updateStatus(item, 'objetiveId', $event)">
                        <option [value]="0">Seleccionar…</option>
                        @for (obj of objetivos; track $index) {
                          <option [value]="obj.id">{{obj.nombre}}</option>
                        }
                      </select>
                    </td>
                  }@else {
                    <td style="text-align: center;">
                      <mat-icon>
                        minimize
                      </mat-icon>
                    </td>
                  }
                  <!-- Estrategia -->
                  @if (item.tipo === 'p') {
                    <td style="max-width: 8vw;">
                      <select
                        class="cell-select"
                        [(ngModel)]="item.programaId"
                        (ngModelChange)="updateStatus(item, 'programaId', $event)">
                        <option [value]="0">Seleccionar…</option>
                        @for (est of item.strategiasFiltro; track $index) {
                          <option [value]="est.id">{{est.name}}</option>
                        }
                      </select>
                    </td>
                  }@else {
                    <td style="text-align: center;">
                      <mat-icon>
                        minimize
                      </mat-icon>
                    </td>
                  }
                  <!-- Responsable -->
                  <td style="max-width: 8vw;">
                    <select
                      class="cell-select"
                      [(ngModel)]="item.responsableId"
                      (ngModelChange)="updateStatus(item, 'responsableId', $event)">
                      <option [value]="0">Seleccionar…</option>
                      @for (res of responsables; track $index) {
                        <option [value]="res.id">{{res.nombre}}</option>
                      }
                    </select>
                  </td>
                  <!-- Inicio -->
                  @if (item.tipo === 'a') {
                    <td style="text-align: center;">
                      {{item.fecha_inicio}}
                    </td>
                  }@else {
                    <td style="text-align: center;">
                      <mat-icon>
                        minimize
                      </mat-icon>
                    </td>
                  }
                  <!-- Fin -->
                  @if (item.tipo === 'a') {
                    <td style="text-align: center;">
                      {{item.fecha_fin}}
                    </td>
                  }@else {
                    <td style="text-align: center;">
                      <mat-icon>
                        minimize
                      </mat-icon>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
          @if (registros.length === 0) {
            <div class="textSinDatos">
              {{'gestion.formulacion.alta-proyectos.sin-datos' | translate}}
            </div>
            <div class="textSin2">
              {{'gestion.formulacion.alta-proyectos.sin-datos2' | translate}}
            </div>
          }
        }@else{
          <table class="tabla-aleema">
            <thead>
              <tr>
                @for (e of encabezados; track e; let i = $index) {
                  @if(i!==0){
                    <th>
                      {{'gestion.formulacion.alta-proyectos.encabezado'+(i+1) | translate}}
                    </th>
                  }
                }
              </tr>
            </thead>
            <tbody>
              @for (item of allProyects; track $index) {
                <tr>
                  <!-- Tipo -->
                  <td style="text-align: center;">
                    <span class="badge"
                    [class.badge-proyecto]="item.tipo === 'p'"
                    [class.badge-actividad]="item.tipo === 'a'">
                      {{'gestion.formulacion.alta-proyectos.'+item.tipo | translate}}
                    </span>
                  </td>
                  <!-- Nombre -->
                  <td style="padding-left: 0.5rem;" [matTooltip]="item.name" [appOverflowTooltip]="item.name">
                    {{item.name}}
                  </td>
                  <!-- Descripcion  -->
                  @if (item.tipo === 'p') {
                    <td style="padding-left: 0.5rem;" [matTooltip]="item.description" [appOverflowTooltip]="item.description">
                      {{item.description}}
                    </td>
                  }@else {
                    <td style="text-align: center;">
                      <mat-icon>
                        minimize
                      </mat-icon>
                    </td>
                  }
                  <!-- Objetivo -->
                  @if (item.tipo === 'p') {
                    <td style="padding-left: 0.5rem;" [matTooltip]="item.objetiveId" [appOverflowTooltip]="item.objetiveId">
                      {{item.objetiveId}}
                    </td>
                  }@else {
                    <td style="text-align: center;">
                      <mat-icon>
                        minimize
                      </mat-icon>
                    </td>
                  }
                  <!-- Estrategia -->
                  @if (item.tipo === 'p') {
                    <td style="padding-left: 0.5rem;" [matTooltip]="item.programaId" [appOverflowTooltip]="item.programaId">
                      {{item.programaId}}
                    </td>
                  }@else {
                    <td style="text-align: center;">
                      <mat-icon>
                        minimize
                      </mat-icon>
                    </td>
                  }
                  <!-- Responsable -->
                  <td style="padding-left: 0.5rem;" [matTooltip]="item.responsableId" [appOverflowTooltip]="item.responsableId">
                    {{item.responsableId}}
                  </td>
                  <!-- Inicio -->
                  @if (item.tipo === 'a') {
                    <td style="text-align: center;">
                      {{item.fecha_inicio}}
                    </td>
                  }@else {
                    <td style="text-align: center;">
                      <mat-icon>
                        minimize
                      </mat-icon>
                    </td>
                  }
                  <!-- Fin -->
                  @if (item.tipo === 'a') {
                    <td style="text-align: center;">
                      {{item.fecha_fin}}
                    </td>
                  }@else {
                    <td style="text-align: center;">
                      <mat-icon>
                        minimize
                      </mat-icon>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </app-contenedor-elementos>
  </div>

</app-esqueleto-tableros>